@import '../../../globals/main.scss';

pn-customernumber-selector-option {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  &:last-of-type {
    border-bottom-left-radius: 0.8rem;
    border-bottom-right-radius: 0.8rem;
  }
}
.customernumberoption {
  overflow: hidden;
  max-width: 100%;
  text-decoration: none;
  background: $white;
  transition: background 0.15s ease;
  padding: 1.6rem 1rem;
  &:hover,
  &:focus,
  &:active {
    background: $blue50;
    text-decoration: none;
  }
}
.customernumberoption-text {
  font-weight: 700;
  color: $gray900;
}

.customernumberoption-title {
  display: block;
  font-size: 1em;
  color: $blue700;
  font-weight: 700;
}

.customernumberoption-description {
  font-size: 0.75em;
  color: $gray700;
  font-weight: normal;
}
